module.exports = __webpack_public_path__ + "img/home_lottery_type6.46e94799.png";